/**
 * Desktop (lg and up) view of the remove-cut confirmation: a closable modal with "Yes, Remove"
 * and "Cancel". Chosen and wired by `./RemoveCutModal.tsx`.
 */
import { useTheme } from "@ryerson/frontend.theme";
import React from "react";
import { RemoveCutModalType } from "./RemoveCutModal";
import { Button } from "@ryerson/frontend.button";
import { Typography } from "@ryerson/frontend.typography";
import { Flex, FlexItem } from "@ryerson/frontend.layout";
import { Modal } from "@ryerson/frontend.modal";

/** Renders the desktop confirmation modal; `showModal` opens it. */
const RemoveCutModalDesktop: React.FC<RemoveCutModalType> = ({
	content,
	showModal,
	handleRemoveCut,
	handleClose,
}) => {
	const { theme } = useTheme();
	const { gray, text } = theme.colors.primary;

	return (
		<>
			<Modal
				title={content.removeCut}
				isOpen={showModal}
				closable={true}
				onClose={handleClose}
				buttonArea={
					<Flex css={{ width: "100%", margin: "20px 0" }}>
						<FlexItem css={{ marginRight: 10 }}>
							<Button
								label={content.yesRemove}
								paddingType="relaxed"
								onClick={handleRemoveCut}
								size="lg"
								dataTestId="remove-cut-modal-remove-button"
							/>
						</FlexItem>
						<FlexItem>
							<Button
								label={content.cancel}
								paddingType="relaxed"
								foreground="light"
								background={gray}
								onClick={handleClose}
								size="lg"
								dataTestId="remove-cut-modal-cancel-button"
							/>
						</FlexItem>
					</Flex>
				}
			>
				<Typography type="tertiary" color={text}>
					{content.areYouSure}
				</Typography>
			</Modal>
		</>
	);
};

export default RemoveCutModalDesktop;
